import { ButtonPopup } from '../ui'; // Botón estilizado reutilizable
import { PopupProps } from '@/types'; // Tipos de props del popup
import { PopupStilosCss } from '../styles'; // Estilos CSS específicos para popups

/**
 * Componente ImagePopup
 * 
 * Modal emergente para seleccionar y subir imágenes. 
 * Llama a `onAddImage` al seleccionar un archivo válido y permite cerrar el popup.
 * 
 * @param {PopupProps} props
 * @param {(file: File) => void} [props.onAddImage] - Callback que recibe el archivo seleccionado.
 * @param {() => void} [props.onClose] - Función que se ejecuta al cerrar el popup.
 * @param {string} [props.className] - Clases CSS adicionales opcionales.
 */
const ImagePopup: React.FC<PopupProps> = ({
  onAddImage,
  onClose,
  className,
}) => {

  // Maneja la selección de archivo
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    // Verifica que sea un archivo de imagen
    if (!file || !file.type.startsWith('image/')) {
      alert('Solo imágenes.');
      return;
    }

    // Llama al callback pasando el archivo seleccionado
    onAddImage?.(file);

    // Cierra el popup después de seleccionar
    onClose?.();
  };

  return (
    // Contenedor principal del popup
    // fixed: posicionado sobre toda la pantalla
    // inset-0: ocupa todo el ancho y alto
    // flex items-center justify-center: centra el contenido
    // bg-black bg-opacity-50: fondo negro semi-transparente
    // z-50: asegura que esté por encima de otros elementos
    <div
      className={`fixed inset-0 ${PopupStilosCss.popupImgTrabajosProfesional} flex items-center justify-center bg-black bg-opacity-70 z-50`}
    >
      {/* Contenedor interno del contenido del popup */}
      {/* Se aplican clases adicionales y estilos específicos del popup */}
      <div
        className={`${className} ${PopupStilosCss.popupImgTrabajosProfesional} space-y-8 bg-zinc-400 shadow-xl rounded-md xs:text-xs p-8 relative overflow-auto`}
      >
        {/* Título del popup */}
        <h2 className="sm:text-xl xs:text-lg">Añadir Imagen</h2>

        {/* Selector de archivo */}
        <div className="text-center w-full">
          <label
            htmlFor="file-upload"
            className="md:px-14 sm:px-10 px-6 py-2 transition-colors dark:text-zinc-700 bg-white rounded-md duration-400 hover:rounded-md border hover:border-green-600 hover:shadow-sm dark:active:bg-zinc-700 text-black-900 active:text-white"
          >
            Seleccionar archivo
          </label>
          {/* Input oculto que dispara handleFileChange al seleccionar un archivo */}
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
        </div>

        {/* Botón de cancelar */}
        <div className="w-full text-center pb-4">
          <ButtonPopup
            type="button"
            onClick={onClose}
            className="h-8 w-6/12 transition-colors bg-zinc-700 shadow-md shadow-zinc-700 rounded-md duration-400 border hover:border-red-600 active:bg-white active:text-black text-white active:font-extrabold"
          >
            Cancelar
          </ButtonPopup>
        </div>
      </div>
    </div>
  );
};

export default ImagePopup;
